import axios from 'axios';
import { BASE_URL, JWT_APP_ID } from '../../config/URL';
import analytic, {
  analyticEvents,
  analyticTypes,
} from '../../service/analytic';
import { generateErrorDetail } from '../../utils';
import { showToastNotif } from './notification';

export const getLiveGame = () => async (dispatch, getState) => {
  const state = getState();
  const token = state.auth.token;

  dispatch({
    type: 'GET_AVAILABLE_LIVE_GAME',
  });

  try {
    const res = await axios.get(`${BASE_URL}/catalog/v1.0/shows/getLiveGame`, {
      headers: {
        Authorization: token,
        'Cloudfront-JWT-AppId': JWT_APP_ID,
      },
    });

    dispatch({
      type: 'GET_AVAILABLE_LIVE_GAME_SUCCESS',
      payload: res.data.data,
    });
    dispatch(getStreamUrlKey());
  } catch (err) {
    dispatch({
      type: 'GET_AVAILABLE_LIVE_GAME_FAILED',
      err,
    });
  }
};

export const createGameStream = (data) => async (dispatch, getState) => {
  const state = getState();
  const { token, user } = state.auth;
  const formData = new FormData();
  formData.append('name', data.name);
  formData.append('description', data.description);
  formData.append('categoryId', data.category.id);
  // formData.append('gameTitle', data.gameTitle)
  formData.append('thumbnail', data.thumbnail);
  formData.append('appId', JWT_APP_ID);
  formData.append('type', 'GAME');
  formData.append('isBroadcasting', false);

  dispatch({ type: 'CREATE_LIVE_GAME' });
  try {
    const res = await axios.post(`${BASE_URL}/catalog/v1.0/shows`, formData, {
      headers: {
        Authorization: token,
        'Cloudfront-JWT-AppId': JWT_APP_ID,
      },
    });

    const payload = res.data.data;
    payload.show.showCategory = data.category;

    dispatch({
      type: 'CREATE_LIVE_GAME_SUCCESS',
      payload,
    });

    const paramsEvent = {
      showID: payload.show.id,
      showName: payload.show.name,
      showCategoryID: payload.show.showCategory.id,
      showCategoryName: payload.show.showCategory.name,
      showType: payload.show.type,
    };
    analytic(analyticTypes.event, analyticEvents.LIVEGAME.CREATE_STREAM, {
      params: paramsEvent,
      user,
    });
  } catch (err) {
    console.log(err);
    dispatch({
      type: 'CREATE_LIVE_GAME_FAILED',
      err,
    });
  }
};

export const editGameStreamInfo = (id, data) => async (dispatch, getState) => {
  const state = getState();
  const { token, user } = state.auth;
  const formData = new FormData();
  formData.append('name', data.name);
  formData.append('description', data.description);
  formData.append('categoryId', data.category.id);
  // formData.append('gameTitle', data.gameTitle)
  if (data.thumbnail instanceof File) {
    formData.append('thumbnail', data.thumbnail);
  }

  dispatch({ type: 'UPDATE_LIVE_GAME' });
  try {
    const res = await axios.put(
      `${BASE_URL}/catalog/v1.0/show/${id}`,
      formData,
      {
        headers: {
          Authorization: token,
          'Cloudfront-JWT-AppId': JWT_APP_ID,
        },
      }
    );
    const payload = res.data.data.show;

    dispatch({
      type: 'UPDATE_LIVE_GAME_INFO_SUCCESS',
      payload,
    });

    const paramsEvent = {
      showID: payload.id,
      showName: payload.name,
      showCategoryID: payload.showCategory.id,
      showCategoryName: payload.showCategory.name,
      showType: payload.type,
    };
    analytic(analyticTypes.event, analyticEvents.LIVEGAME.EDIT_STREAM, {
      params: paramsEvent,
      user,
    });

    dispatch(showToastNotif('success', 'Success update stream info'));
  } catch (err) {
    console.log(err);
    dispatch({
      type: 'UPDATE_LIVE_GAME_INFO_FAILED',
      err,
    });
    dispatch(showToastNotif('success', 'Failed to update stream info'));
  }
};

export const getStreamUrlKey = () => async (dispatch, getState) => {
  const state = getState();
  const token = state.auth.token;

  dispatch({
    type: 'GET_STREAM_URL_KEY',
  });
  try {
    const res = await axios.get(`${BASE_URL}/catalog/v1.0/shows/getRtmp`, {
      headers: {
        Authorization: token,
        'Cloudfront-JWT-AppId': JWT_APP_ID,
      },
    });

    dispatch({
      type: 'GET_STREAM_URL_KEY_SUCCESS',
      payload: res.data.data,
    });
  } catch (err) {
    dispatch({
      type: 'GET_STREAM_URL_KEY_FAILED',
      err,
    });
  }
};

export const resetStreamKey = () => async (dispatch, getState) => {
  const state = getState();
  const token = state.auth.token;

  dispatch({
    type: 'RESET_STREAM_KEY',
  });
  try {
    const res = await axios.post(
      `${BASE_URL}/catalog/v1.0/shows/resetRtmp`,
      null,
      {
        headers: {
          Authorization: token,
          'Cloudfront-JWT-AppId': JWT_APP_ID,
        },
      }
    );

    dispatch({
      type: 'RESET_STREAM_KEY_SUCCESS',
      payload: res.data.data,
    });
  } catch (err) {
    dispatch({
      type: 'RESET_STREAM_KEY_FAILED',
      err,
    });
  }
};

export const broadcasting = () => async (dispatch, getState) => {
  const state = getState();
  const { token, user } = state.auth;
  const { liveGameInfo } = state.liveGame;
  const isBroadcasting = liveGameInfo && liveGameInfo.isBroadcasting;

  dispatch({
    type: 'BROADCASTING',
  });
  try {
    if (isBroadcasting) {
      await dispatch(stopLiveGame());
    } else {
      await axios.post(
        `${BASE_URL}/catalog/v1.0/show/${liveGameInfo.id}/startBroadcasting`,
        null,
        {
          headers: {
            Authorization: token,
            'Cloudfront-JWT-AppId': JWT_APP_ID,
          },
        }
      );

      dispatch({
        type: 'START_LIVE_GAME_SUCCESS',
      });
      dispatch(showToastNotif('success', 'Start Streaming'));
      if (liveGameInfo) {
        const paramsEvent = {
          showID: liveGameInfo.id,
          showName: liveGameInfo.name,
          showCategoryID: liveGameInfo.showCategory.id,
          showCategoryName: liveGameInfo.showCategory.name,
          showType: liveGameInfo.type,
        };
        analytic(analyticTypes.event, analyticEvents.LIVEGAME.START_STREAM, {
          params: paramsEvent,
          user,
        });
      }
    }
  } catch (err) {
    console.log(err);

    dispatch(showToastNotif('error', 'Connection Error'));
  }
};

export const stopLiveGame = () => async (dispatch, getState) => {
  const state = getState();
  const { token, user } = state.auth;
  const { liveGameInfo } = state.liveGame;
  const liveId = liveGameInfo && liveGameInfo.id;

  dispatch({
    type: 'STOP_LIVE_GAME',
  });
  try {
    await axios.post(`${BASE_URL}/catalog/v1.0/show/${liveId}/stop`, null, {
      headers: {
        Authorization: token,
        'Cloudfront-JWT-AppId': JWT_APP_ID,
      },
    });

    dispatch({
      type: 'STOP_LIVE_GAME_SUCCESS',
    });
    if (liveGameInfo) {
      const paramsEvent = {
        showID: liveGameInfo.id,
        showName: liveGameInfo.name,
        showCategoryID: liveGameInfo.showCategory.id,
        showCategoryName: liveGameInfo.showCategory.name,
        showType: liveGameInfo.type,
      };
      analytic(analyticTypes.event, analyticEvents.LIVEGAME.END_STREAM, {
        params: paramsEvent,
        user,
      });
    }
  } catch (err) {
    dispatch({
      type: 'STOP_LIVE_GAME_FAILED',
      err,
    });
  }
};

export const handleCheckEditButtonLiveShow =
  (id) => async (dipatch, getState) => {
    const state = getState();
    const { token } = state.auth;

    try {
      const response = await axios.get(
        `${BASE_URL}/catalog/v1.0/videos/existed?showId=${id}`,
        {
          headers: {
            Authorization: token,
            'Cloudfront-JWT-AppId': JWT_APP_ID,
          },
        }
      );
      return response?.data?.data;
    } catch (err) {
      const errorData = generateErrorDetail(err);
      console.log(errorData);
    }
  };
